// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__q1hMN","pageItem":"styles_pageItem__pHbum","disabled":"styles_disabled__Mql4y","pageLink":"styles_pageLink__EO7Pm","active":"styles_active__ZpVNm"};